import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import { Body, SmallBody } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";
import { askForSeats } from "store/adminPanelSlice";
import { useAppDispatch } from "store/store";

import styles from "./style.module.scss";

interface IAskForSeatsModal {
    open: boolean;
    onClose: () => void;
}
// Modal for asking new publisher seats
const AskForSeatsModal = ({ open, onClose }: IAskForSeatsModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const askForMoreSeats = () => {
        dispatch(askForSeats());
        onClose();
    };

    return (
        <ModalBox open={open} onClose={onClose} mainTitle={t("Members.NoAvailableSeats")}>
            <div className={styles["ask-for-seats-modal"]}>
                <div className={styles["body"]}>
                    <Body color="black">{t("Members.AllSeatsUsed")}</Body>
                    <SmallBody color="info">{t("Members.AddMore")}</SmallBody>
                </div>
                <div className={styles["action-buttons"]}>
                    <StyledButton buttonType="secondary" onClick={onClose}>
                        {t("Members.NoCancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" onClick={askForMoreSeats}>
                        {t("Members.AskForMoreSeats")}
                    </StyledButton>
                </div>
            </div>
        </ModalBox>
    );
};

export default AskForSeatsModal;
